var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"flat":""}},[_c('v-col',[_c('v-card',[_c('v-card-title',{staticClass:"text-h5"},[_vm._v(" Well done ! No More card to learn for this session ")]),_c('div',[_c('Chart',{attrs:{"values":_vm.boxesSummary}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }